export const ADD_TODO = "ADD_TODO"
export const  EDIT_ITEM  ="EDIT_ITEM"
export const DEL_ITEM = "DEL_ITEM"
export const CHECK_BOX = "CHECK_BOX"
export const CLEAR_COMPLETE_TASK = "CLEAR_COMPLETE_TASK"